/**
 * Generic Api Error.
 */
export class ApiError extends Error {
  code: string
  status?: number

  constructor (message: string, code: string, status?: number) {
    super(message)
    this.name = this.constructor.name

    this.code = code
    this.status = status
  }
}
